import React from "react";
import { Grid } from "@material-ui/core/";
import Aux from "../../../hoc/Auxilliary";
import ClassGrades from "../../../components/Faculty/ClassGrades";

const ClassGradesPage = (props) => {
  return (
    <Aux>
      <Grid container>
        <Grid item container xs={12} sm={10} style={{ margin: "0 auto" }}>
          <ClassGrades {...props} />
        </Grid>
      </Grid>
    </Aux>
  );
};

export default ClassGradesPage;
